import createVueComponent from '../createVueComponent';
var SortAsc = createVueComponent('SortAscIcon', [['path', {
  d: 'M11 5h4',
  key: 'rewg9q'
}], ['path', {
  d: 'M11 9h7',
  key: '13ra05'
}], ['path', {
  d: 'M11 13h10',
  key: '1gdh8d'
}], ['path', {
  d: 'm3 17 3 3 3-3',
  key: 'd2bl7z'
}], ['path', {
  d: 'M6 18V4',
  key: '20vmay'
}]]);
export default SortAsc;